import { useEffect, useRef } from "react";
import { useAppContext } from "@/Components/Providers/AppProvider";
import WhatWeDoSection from "./WhatWeDoSection";
import FairShareModelSection from "./FairShareModelSection";
import OurTalentSection from "./OurTalentSection";

type Props = {};

export default function About({}: Props) {
    const { homepageAnchors: { about }} = useAppContext();

    return <>
        <FairShareModelSection ref={about} />
        <WhatWeDoSection />
        <OurTalentSection />
    </>;
}
